function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Convert WASP"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M3.81818 20.1818H2V14.7273H7.45455V16.5455H5.2C6.66364 18.7364 9.16364 20.1818 12 20.1818C14.17 20.1818 16.251 19.3198 17.7854 17.7854C19.3198 16.251 20.1818 14.17 20.1818 12H22C22 17.5273 17.5273 22 12 22C8.61818 22 5.62727 20.3182 3.81818 17.7545V20.1818ZM2 12C2 6.47273 6.47273 2 12 2C15.3818 2 18.3727 3.68182 20.1818 6.24545V3.81818H22V9.27273H16.5455V7.45455H18.8C17.3364 5.26364 14.8364 3.81818 12 3.81818C9.83005 3.81818 7.74897 4.68019 6.21458 6.21458C4.68019 7.74897 3.81818 9.83005 3.81818 12H2Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 2",
  cx: 12,
  cy: 12,
  r: 2,
  fill: "none"
}));

var SvgConverWasp = function SvgConverWasp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConverWasp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conver_wasp.cedefc44.svg";
export { ForwardRef as ReactComponent };